import React, { Component } from 'react';

import { Marker } from 'google-maps-react';

import pruningGreenIcon from '../../../images/pruning_green.svg'
import pruningRedIcon from '../../../images/pruning_red.svg'

class PruningIcon extends Component {

    componentDidMount() {
        this.loadPruningMarkers();
    }

    shouldComponentUpdate(nextProps) {
        if (this.props.pruningList.length !== nextProps.pruningList.length
            || this.props.showPruningLayer !== nextProps.showPruningLayer
            || this.props.showPruningIcons !== nextProps.showPruningIcons
            || this.props.zoomLevel !== nextProps.zoomLevel
            || this.props.poleSize !== nextProps.poleSize) {
            return true;
        }
        else {
            return false
        }
    }

    componentDidUpdate() {
        this.loadPruningMarkers();
    }

    loadPruningMarkers = () => {
        let resultList = [];

        if (this.props.showPruningLayer
            && this.props.pruningList
            && this.props.pruningList.length > 0
            && this.props.zoomLevel > 0
            && this.props.showPruningIcons) {
            this.props.pruningList.forEach((prune, index) => {
                let pruningIcon = prune.isUrgent ? pruningRedIcon : pruningGreenIcon;
                let pruneIcon =
                    <Marker
                        options={{ icon: { url: pruningIcon, scaledSize: { width: this.props.poleSize, height: this.props.poleSize } } }}
                        key={index}
                        onClick={this.props.onPruningClick}
                        position={prune.position}
                        title={'Pruning area - OHL: ' + prune.ohl + ' Span: ' + prune.span + ' Is urgent: ' + prune.isUrgent}
                        ohl={prune.ohl}
                        span={prune.span}
                        isUrgent={prune.isUrgent}
                        vegetationType={prune.vegetationType}
                        height={prune.height}
                        contact={prune.contact}
                    />;
                resultList.push(pruneIcon);
            });
        }

        this.props.sendChildElementDataToState(this.props.stateElementName, resultList);
    }

    render() {
        return null;
    }
}

export default PruningIcon;

